import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Main from './Component/Main';
import App from './App';
import Myskills from './Component/Projects';
import { BrowserRouter } from 'react-router-dom';



import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className='bg-[url("Artboard2.svg ")]'>
     


      <App />
     

  

    </div>
   
 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
